import { Button, DataSource, HorizontalSpacer, Label, Layout, Panel, Table } from "@mcleod/components";

export abstract class AutogenLayoutPartnerProfileManagementTable extends Layout {
    buttonExpand: Button;
    horizontalspacer1: HorizontalSpacer;
    labelTitle: Label;
    panelButtons: Panel;
    panelCollapsible: Panel;
    panelHeader: Panel;
    panelTable: Panel;
    sourcePartnerProfileManagement: DataSource;
    tableProfiles: Table;
}
